import React, { useState, useEffect } from 'react';
import { IoIosArrowUp } from "react-icons/io";
import './ScrollToTopButton.css'; // Import CSS file for styling (you can customize it)

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show the button when the user scrolls down 200 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Attach the event listener
    window.addEventListener('scroll', toggleVisibility);

    // Detach the event listener on cleanup
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: smooth scrolling animation
    });
  };

  return (
    <div className={`scroll-to-top-button ${isVisible ? 'show' : ''}`} onClick={scrollToTop}>
      <IoIosArrowUp /> {/* You can replace this with your preferred arrow icon */}
    </div>
  );
}

export default ScrollToTopButton;
